import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const buttonClickSound = createInterfaceSound('/sound/emin.wav');

const playButtonClickSound = () => {
    buttonClickSound.currentTime = 0;
    playInterfaceSound(buttonClickSound).catch(() => undefined);
};

const isDisabledButton = (button: Element) => (
    button.classList.contains('v-btn--disabled') ||
    button.classList.contains('disabled') ||
    button.getAttribute('disabled') !== null ||
    button.getAttribute('aria-disabled') === 'true'
);

const hasIconLigature = (button: Element, iconName: string) => {
    const icons = Array.from(button.querySelectorAll('.v-icon'));
    return icons.some(icon => {
        const textMatch = (icon.textContent || '').includes(iconName);
        const classMatch = icon.classList.contains(iconName);
        return textMatch || classMatch;
    });
};

const shouldSkipButtonSound = (button: Element, target: Element) => {
    // Settings cog in session cards
    if (button.querySelector('.cogIcon') || hasIconLigature(button, 'mdi-cog')) {
        return true;
    }

    // Buttons that open drawers/sheets: session list, chat list, transfers, command center
    if (target.closest('.transferyWrap') || target.closest('.hidableChatWidget')) {
        return true;
    }

    if (button.classList.contains('allCenter') || target.closest('.allCenter')) {
        return true;
    }

    if (
        hasIconLigature(button, 'mdi-format-list-bulleted-type') ||
        hasIconLigature(button, 'chat_bubble_outline') ||
        hasIconLigature(button, 'mdi-rocket') ||
        hasIconLigature(button, 'mdi-apps') ||
        hasIconLigature(button, 'mdi-information-outline') ||
        hasIconLigature(button, 'mdi-order-bool-ascending-variant')
    ) {
        return true;
    }

    return false;
};

const shouldPlayForSessionCard = (target: Element) => {
    const sessionCard = target.closest('.clickable-session, .clickable-drawer-session, .clickable-drawer-button, .newSessionFrame, .clickable-card');
    if (!sessionCard) {
        return false;
    }

    // Keep settings cog excluded from emin.wav.
    if (target.closest('.cogIcon')) {
        return false;
    }

    const cogButton = target.closest('.v-btn');
    if (cogButton && hasIconLigature(cogButton, 'mdi-cog')) {
        return false;
    }

    return true;
};

const onButtonInteraction = (target: EventTarget | null) => {
    if (!(target instanceof Element)) {
        return;
    }

    if (shouldPlayForSessionCard(target)) {
        playButtonClickSound();
        return;
    }

    const menuButtonElement = target.closest('.btn');
    const buttonElement = target.closest('.v-btn') || menuButtonElement?.querySelector('.v-btn');
    if (!buttonElement || isDisabledButton(buttonElement) || menuButtonElement?.classList.contains('btn--disabled')) {
        return;
    }

    if (shouldSkipButtonSound(buttonElement, target)) {
        return;
    }

    playButtonClickSound();
};

document.addEventListener('click', event => {
    onButtonInteraction(event.target);
}, true);

document.addEventListener('keydown', event => {
    if (event.key !== ' ' && event.key !== 'Enter') {
        return;
    }

    onButtonInteraction(event.target);
}, true);
